var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 716.66664 716.66664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #7c7c7c;\n      }\n\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #c6c6c6;\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.607,97.06467A208.20652,208.20652,0,0,0,91.66666,300a25,25,0,1,1-50,0C41.66667,157.193,157.193,41.66667,300,41.66667A24.99988,24.99988,0,0,1,321.43731,79.529l-34.99965,58.33333A25,25,0,0,1,243.563,112.13766ZM733.33331,475a25.00058,25.00058,0,0,1,25,25C758.3333,642.80666,642.80666,758.3333,500,758.3333A25.00171,25.00171,0,0,1,478.56332,720.47l35-58.33334a24.99992,24.99992,0,1,1,42.87331,25.7267l-9.04331,15.07333A208.20976,208.20976,0,0,0,708.33331,500,25.00058,25.00058,0,0,1,733.33331,475Z",
    transform: "translate(-41.66667 -41.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546.66333,273.66532,421.33,205.99865a45.29446,45.29446,0,0,0-42.33335,0L253.663,273.66532a29.79269,29.79269,0,0,0,0,51.33333l125.33365,67.668a45.33341,45.33341,0,0,0,42.66669,0l125.33334-67.668A29.00936,29.00936,0,0,0,561.66329,299.332C561.33,288.332,555.66334,278.66531,546.66333,273.66532Z",
    transform: "translate(-41.66667 -41.66667)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.00665,415.66332,241.341,357.33a28.89452,28.89452,0,0,0-27.99967,1.33333,28.22584,28.22584,0,0,0-13.667,24.33332V493.33a49.61453,49.61453,0,0,0,27.66733,44.66667L344.01,596.33a28.64789,28.64789,0,0,0,12.99667,3,27.06617,27.06617,0,0,0,15-4.33337,28.22853,28.22853,0,0,0,13.67-24.33332V460.33A49.39136,49.39136,0,0,0,358.00665,415.66332Z",
    transform: "translate(-41.66667 -41.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.33,358.66332A28.895,28.895,0,0,0,558.33,357.33l-116.6667,58.33333A49.98543,49.98543,0,0,0,413.99665,460.33V570.6633a28.2254,28.2254,0,0,0,13.66666,24.33332,27.06614,27.06614,0,0,0,15,4.33337,30.79294,30.79294,0,0,0,13-3L572.33,537.99665A49.98558,49.98558,0,0,0,599.99667,493.33V382.99664A28.22554,28.22554,0,0,0,586.33,358.66332Z",
    transform: "translate(-41.66667 -41.66667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.f09ee167.svg";
export { ForwardRef as ReactComponent };